const enTranslations = {
  "errors.duplicateProfileMobile":
    "A profile with this mobile number already exists. The same mobile number cannot be registered again in this or any other bureau.",
  "navbar.home": "Home",
  "navbar.menu.search": "Search",
  "navbar.myProfiles": "My Profiles",
  "navbar.profileMenu.myProfile": "My Profile",
  "navbar.editPrivacy": "Edit Bureau Privacy",
  "navbar.terms": "Terms & Conditions",
  "navbar.logout": "Logout",
  "navbar.language": "Language",
  "navbar.language.english": "En",
  "navbar.language.telugu": "తె",
  "navbar.notificationsTitle": "Notifications",
  "navbar.notificationsEmpty": "No new notifications",
  "navbar.notificationsViewAll": "View all notifications",
  "navbar.notificationsNewInterest": "New interest received from Bureau ID: ",
  "navbar.idLabel": "ID:",
  "navbar.mobile.maleProfiles": "New Male Profiles",
  "navbar.mobile.femaleProfiles": "New Female Profiles",
  "navbar.mobile.otherProfiles": "Other Profiles",
  "navbar.mobile.notifications": "My Notifications",
  "navbar.mobile.terms": "Terms & Conditions",
  "navbar.mobile.community": "Follow Community Guidelines & Terms",
  "navbar.mobile.editPassword": "Edit Password",
  "navbar.mobile.editPrivacy": "Edit Bureau Privacy",
  "navbar.mobile.editWebsite": "Edit Website",
  "navbar.mobile.howToUse": "How to Use",
  "navbar.mobile.updatePhoto": "Update Profile Picture",
  "navbar.mobile.logout": "Logout",
  "navbar.mobile.language": "Language",
  "dashboard.noProfiles": "No profiles found in this section yet.",
  "dashboard.sections.yourProfiles": "New Profiles",
  "dashboard.sections.pendingProfiles": "Incomplete Profiles",
  "dashboard.sections.freeProfiles": "Free Profiles",
  "dashboard.sections.paidProfiles": "Paid Profiles",
  "dashboard.sections.redzoneProfiles": "Red Zone Profiles",
  "dashboard.sections.callBackProfiles": "Call Back Profiles",
  "dashboard.sections.notRespondingProfiles": "Not Responding Profiles",
  "dashboard.sections.otherMediatorProfiles": "Added by Other Mediator Profiles",
  "dashboard.sections.otherProfiles": "Other Bureau Profiles",
  "dashboard.sections.shortlisted": "Shortlisted Profiles",
  "dashboard.sections.male": "Male",
  "dashboard.sections.female": "Female",
  "dashboard.count.default": "Profiles",
  "dashboard.count.pending": "Pending",
  "dashboard.count.shortlisted": "Shortlisted",
  "dashboard.buttons.viewAll": "View All",
  "dashboard.buttons.viewAllMale": "View All New Male Profiles",
  "dashboard.buttons.viewAllFemale": "View All New Female Profiles",
  "dashboard.buttons.reviewPendingMale": "Review Pending Male Profiles",
  "dashboard.buttons.reviewPendingFemale": "Review Pending Female Profiles",
  "dashboard.buttons.exploreOtherMale": "Explore Other Bureau Male Profiles",
  "dashboard.buttons.exploreOtherFemale":
    "Explore Other Bureau Female Profiles",
  "dashboard.buttons.viewAllShortlisted": "View All Shortlisted Profiles",
  "dashboard.buttons.viewAllFree": "View All Free Profiles",
  "dashboard.buttons.viewAllPaid": "View All Paid Profiles",
  "dashboard.buttons.viewAllRedzone": "View All Red Zone Profiles",
  "dashboard.buttons.viewAllCallBack": "View All Call Back Profiles",
  "dashboard.buttons.viewAllNotResponding":
    "View All Not Responding Profiles",
  "dashboard.buttons.viewAllOtherMediator": "View All Other Mediator Profiles",
  "searchById.title": "Search By ID",
  "searchById.fields.martialId": "Martial ID",
  "searchById.fields.martialIdPlaceholder": "Enter Martial ID",
  "searchById.actions.search": "Search",
  "searchById.errors.requiredMartialId": "Please enter a Martial ID.",
  "Edit Profile": "Edit Profile",
  "Community Guidelines": "Community Guidelines",
  "How to Use": "How to Use",
  "Edit Website": "Edit Website",
  "Change Password": "Change Password",
  "Bureau Privacy": "Bureau Privacy",
  "Change Profile Picture": "Change Profile Picture",
  "Share Your Website": "Share Your Website",
  "Share Your visiting card": "Share Your visiting card",
  "Share your website QR": "Share your website QR",
  "bottomNav.home": "Home",
  "bottomNav.search": "Search",
  "bottomNav.addProfile": "Add Profile",
  "bottomNav.shareUrl": "Share Web",
  "bottomNav.myWeb": "My Web",
  "bottomNav.modal.title": "Add Profile",
  "bottomNav.modal.description": "Choose how you want to create the profile:",
  "bottomNav.modal.own": "Add Your Own Profile",
  "bottomNav.modal.mediator": "Add Mediator Profile",
  "bottomNav.modal.addViaText": "Paste Biodata Text",
  "bottomNav.modal.addViaImage": "Upload Biodata Image",
  "bottomNav.modal.addBasic": "Add Basic Details",
  "bottomNav.modal.addManually": "Add Full Details (Recommended)",
  "bottomNav.modal.addFullRecommended": "Add Full Details (Recommended)",
  "bottomNav.modal.cancel": "Cancel",
  callBack: "Call Back",
  notResponding: "Not Responding",
  "Call Back Profiles": "Call Back Profiles",
  "Not Responding Profiles": "Not Responding Profiles",
  "Move to Call Back": "Move to Call Back",
  "Move to Not Responding": "Move to Not Responding",
  "Follow up": "Follow up",
  "alerts.suspended.accountTitle": "Your business account is suspended.",
  "alerts.suspended.accountDescription": "Please contact customer care.",
  "alerts.suspended.websiteTitle":
    "This website is suspended.",
  "alerts.suspended.websiteDescription": "Please alert all users.",
  "matches.filters.all": "All",
  "matches.labels.score": "Score",
  "matches.labels.public": "Public",
  "matches.laebels.private": "Private",
  "matches.labels.views": "Views",
  "matches.labels.viewsCount": "{count} Views",
  "matches.labels.lastSeen": "Last seen",
  "matches.labels.createdBy": "Created by",
  "matches.labels.by": "By",
  "matches.buttons.viewProfile": "View Profile",
  "matches.buttons.view": "View",
  "matches.buttons.switch": "Switch",
  "matches.buttons.manage": "Manage",
  "matches.buttons.manageProfile": "Manage Profile",
  "matches.buttons.share": "Share",
  "matches.buttons.report": "Report",
  "matches.buttons.retry": "Retry",
  "matches.buttons.refresh": "Refresh",
  "matches.messages.empty":
    "No matches available right now. Please adjust filters or try again later.",
  "matches.messages.loading": "Loading more matches…",
  "matches.messages.end": "You've reached the end of the list.",
  "matches.count.withTotal": "Showing {visible} of {total} Matches",
  "matches.count.noTotal": "{visible} Matches Found",
  "Your customer website is pending.": "Your customer website is pending.",
  "Preview Website": "Preview Website",
  "Your customer leads": "Your customer leads",
  Calls: "Calls",
  WhatsApp: "WhatsApp",

  // new
  "Complete Your Website Setup": "Complete Your Website Setup",
  Completed: "Completed",
  Pending: "Pending",
  "Failed to load dashboard data.": "Failed to load dashboard data.",
  "Unable to load dashboard data. Please try again shortly.":
    "Unable to load dashboard data. Please try again shortly.",
  "Loading brand value metrics...": "Loading brand value metrics...",
  "Your Business Score": "Your Business Score",
  "Complete Profiles:": "Complete Profiles:",
  profile: "profile",
  profiles: "profiles",
  "crossed 80% data completeness": "crossed 80% data completeness",
  "No profiles have crossed 80% data completeness yet.":
    "No profiles have crossed 80% data completeness yet.",
  "Each 80% complete profile adds +0.1% to your brand value.":
    "Each 80% complete profile adds +0.1% to your brand value.",
  "Complete your first profile to start growing your brand value.":
    "Complete your first profile to start growing your brand value.",
  "Based on {{count}} profile with completeness data.":
    "Based on {{count}} profile with completeness data.",
  "Based on {{count}} profiles with completeness data.":
    "Based on {{count}} profiles with completeness data.",
  "Your Profiles": "Your Profiles",
  "Pending Profiles": "Pending Profiles",
  "Other Profiles": "Other Profiles",
  Male: "Male",
  Female: "Female",
  Shortlisted: "Shortlisted",
  yrs: "yrs",
  "Match Score:": "Match Score:",
  "No profiles found.": "No profiles found.",
  "View All": "View All",
  "Review Pending": "Review Pending",
  Explore: "Explore",
  "View All Shortlisted": "View All Shortlisted",
  "Add Website Details": "Add Website Details",
  "Update your business name, tagline, and about section.":
    "Update your business name, tagline, and about section.",
  "Add Social Links": "Add Social Links",
  "Update your social media links for your website footer.":
    "Update your social media links for your website footer.",
  "Add Business Video Links": "Add Business Video Links",
  "Add YouTube or business video links to your website.":
    "Add YouTube or business video links to your website.",
  "Add Slider Banners": "Add Slider Banners",
  "Upload at least 3 banner images for your homepage slider.":
    "Upload at least 3 banner images for your homepage slider.",
  "Add Terms & Conditions": "Add Terms & Conditions",
  "Publish your terms and conditions for transparency.":
    "Publish your terms and conditions for transparency.",
  "Add Success Stories": "Add Success Stories",
  "Add customer success stories to build trust.":
    "Add customer success stories to build trust.",
  "Add Testimonials": "Add Testimonials",
  "Add client testimonials to enhance credibility.":
    "Add client testimonials to enhance credibility.",
  "Add Services": "Add Services",
  "List the services offered by your bureau.":
    "List the services offered by your bureau.",
  shortlist: "Shortlist",
  Edit: "Edit",
  personal_information: "Personal Information",
  date_of_birth: "Date of Birth",
  age: "Age",
  birth_place: "Birth Place",
  birth_time: "Birth Time",
  height: "Height",
  weight: "Weight",
  body_type: "Body Type",
  languages_known: "Languages Known",
  marital_status: "Marital Status",
  lives_in: "Lives In",

  habits: "Habits",
  eating_habits: "Eating Habits",
  smoking_habits: "Smoking Habits",
  drinking_habits: "Drinking Habits",

  religion_caste_details: "Religion & Caste Details",
  religion: "Religion",
  mother_tongue: "Mother Tongue",
  caste: "Caste",
  sub_caste: "Sub Caste",
  gothram: "Gothram",
  dosham: "Dosham",
  UncleGothram: "Uncle Gothram",

  horoscope_information: "Horoscope Information",
  star: "Star",
  rashi: "Rashi",

  professional_details: "Professional Details",
  education: "Education",
  employment: "Employment",
  occupation: "Occupation",
  income: "Annual Income",
  job_location: "Job Location",

  family_details: "Family Details",
  father_employee: "Father Employee",
  father_occupation: "Father Occupation",
  mother_employee: "Mother Employee",
  mother_occupation: "Mother Occupation",
  family_type: "Family Type",
  family_value: "Family Value",
  total_brothers: "Total Brothers",
  elder_brothers: "Elder Brothers",
  younger_brothers: "Younger Brothers",
  total_sisters: "Total Sisters",
  elder_sisters: "Elder Sisters",
  younger_sisters: "Younger Sisters",
  native_place: "Native Place",

  property_details: "Property Details",
  house_type: "House Type",
  number_of_houses: "Number of Houses",
  house_sq_feet: "House Sq. Feet",
  house_value: "House Value",
  house_location: "House Location",
  commercial_property: "Commercial Property",
  monthly_rent: "Monthly Rent",
  open_plots: "Open Plots",
  open_plots_sq_yards: "Open Plots Sq. Yards",
  open_plots_value: "Open Plots Value",
  agriculture_land: "Agriculture Land",
  agriculture_land_value: "Agriculture Land Value",
  total_property_value: "Total Property Value",

  contact_information: "Contact Information",
  about_myself: "About Myself",
  extra_talented_skills: "Extra Talented Skills",
  partner_preference: "Partner Preference",

  // Report Modal
  "report.title": "Report Profile",
  "report.reportingProfile": "Reporting Profile:",
  "report.maritalId": "Marital ID:",
  "report.reasonLabel": "Reason for Reporting *",
  "report.reasonPlaceholder": "Select a reason...",
  "report.detailsLabel": "Additional Details (Optional)",
  "report.detailsPlaceholder":
    "Please provide more details about your report...",
  "report.submitting": "Reporting...",
  "report.submit": "Submit Report",

  // Contact Section
  "contact.upgradeMessage": "Upgrade to view contact information.",
  "contact.viewDetails": "View Contact Details →",
  "contact.protectedBy": "This profile is protected by",
  "contact.marriageBureau": "Marriage Bureau",
  "contact.ownerName": "Owner Name:",
  "contact.bureauAddress": "Bureau Address:",
  "contact.contact": "Contact:",
  "contact.call": "Call",
  "contact.whatsapp": "WhatsApp",
  "contact.mobileNumber": "Mobile Number:",

  // Partner Preferences Sections
  "preferences.basic": "Basic Preferences",
  "preferences.religious": "Religious Preferences",
  "preferences.property": "Property Preferences",
  "preferences.professional": "Professional Preferences",
  "preferences.location": "Location Preferences",
  "preferences.horoscope": "Horoscope Preferences",
  "preferences.habits": "Habits Preferences",

  "preferences.preferredAge": "Preferred Age",
  "preferences.preferredHeight": "Preferred Height",
  "preferences.preferredMaritalStatus": "Preferred Marital Status",
  "preferences.physicalStatus": "Physical Status",
  "preferences.eatingHabits": "Eating Habits",
  "preferences.drinkingHabits": "Drinking Habits",
  "preferences.smokingHabits": "Smoking Habits",
  "preferences.preferredReligion": "Preferred Religion",
  "preferences.preferredMotherTongue": "Preferred Mother Tongue",
  "preferences.preferredCaste": "Preferred Caste",
  "preferences.preferredSubcaste": "Preferred Subcaste",
  "preferences.preferredHouseType": "Preferred House Type",
  "preferences.preferredHouseSqYards": "Preferred House Sq. Yards",
  "preferences.preferredMonthlyRent": "Preferred Monthly Rent",
  "preferences.preferredOpenPlot": "Preferred Open Plot",
  "preferences.preferredFlat": "Preferred Apartment/Flat",
  "preferences.preferredOwnLocation": "Preferred Own Location",
  "preferences.preferredAgriculturalLand": "Preferred Agricultural Land",
  "preferences.totalPropertyValue": "Total Property Value",
  "preferences.preferredEducation": "Preferred Education",
  "preferences.preferredEmployment": "Preferred Employment",
  "preferences.preferredOccupation": "Preferred Occupation",
  "preferences.preferredAnnualIncome": "Preferred Annual Income",
  "preferences.preferredFamily": "Preferred Family",
  "preferences.preferredSettledLocation": "Preferred Settled Location",
  "preferences.preferredCountry": "Preferred Country",
  "preferences.preferredState": "Preferred State",
  "preferences.preferredCity": "Preferred City",
  "preferences.preferredCitizenship": "Preferred Citizenship",
  "preferences.preferredStar": "Preferred Star",
  "preferences.preferredRashi": "Preferred Rashi",
  "preferences.preferredDosham": "Preferred Dosham",
  createdAt: "CreatedAt: ",
  createdBySuperAdmin: "createdBySuperAdmin",
  onlineOffline: "onlineOffline",
  "Profile Creation Steps": "Profile Creation Steps",
  "Basic Info": "Basic Info",
  "Education Details": "Education Details",
  "Family Details": "Family Details",
  "Property Details": "Property Details",
  "Agriculture & Flat Details": "Agriculture & Flat Details",
  "Location Details": "Location Details",
  "Partner Preferences": "Partner Preferences",
  photosDocuments: "photosDocuments",
  progress: "Progress",
  step: "step",
  of: "of",
  "Full Name": "Full Name",
  Password: "Password",
  "Contact Number": "Contact Number",
  "Mediator Contact Number": "Mediator Contact Number",
  "step1.selectGender": "Select Gender",
  "step1.self": "Self",
  "step1.indianProfile": "Indian Profile",
  "step1.gender": "Gender",
  "step1.createdBy": "Created By",
  "Click the icon to upload your photo": "Click the icon to upload your photo",
  male_kids: "Male Kids",
  female_kids: "Female Kids",
  select: "Select",

  are_children_with_you: "Are the born children with you?",
  "contact.details.warning":
    "You have not yet completed adding 50 profiles, so we cannot show you the contact details of other Bureau profiles.",
  "Download Biodata": "Download Biodata",
  "Contact Details": "Contact Details",
  skip: "skip",
  "birth time": "Birth time",
  commercialSqYards: "commercialSqYards",
  plotLocation: "plotLocation",
  flatType: "flatType",
  flatValue: "flatValue",
  "Share your website": "Share your website",
  "Preview your website": "Preview your website",
};

export default enTranslations;
